export default __webpack_public_path__ + "static/media/Q19_1_resized.22d388cf.jpg";